/* ---- DOM manipulation ---- */
const [mainItemsGrid, otherItemsGrid] = ['main', 'other'].map(gridType =>
  document.querySelector(`.product__mixed-styles-items--${gridType}-items .product-grid`),
);
const [mainItemsTitle, otherItemsTitle] = ['main', 'other'].map(gridType =>
  document.querySelector(
    `.product__mixed-styles-items--${gridType}-items .product__media-wrapper-title > p`,
  ),
);

const mainItemsSubtitle = document.querySelector('.product__media-wrapper-subtitle');

const otherItemsWrapper = document.querySelector('.product__mixed-styles-items--other-items');
const loadMoreWrapper = document.querySelector('.load-more');
const loadMoreButton = document.querySelector('.load-more .load-more__btn');
const loadMoreSpinner = document.querySelector('.load-more .load-more__spinner');

/* ------- Vars ------ */
const param = 'query-inventoryItems';
const partnerUuid = localStorage.getItem('partnerUuid');

/* ---- Functions ---- */
/**
 * Fetches <numberOfItems> items for the given parentSku/sizeCodes/colorCodes/conditionCodes combo.
 *
 * @param {*} parentSku
 * @param {*} sizeCodes
 * @param {*} colorCodes
 * @param {*} conditionCodes
 * @param {*} page
 * @param {*} pageSize
 * @returns a promise that resolves to an object with properties items (the list of items) and
 * totalCount.
 */

async function fetchMixedStylesItems({
  parentSku,
  sizeCodes,
  colorCodes,
  conditionCodes,
  page,
  pageSize,
  sortBy,
}) {
  const shopifyCart = await getShopifyResource('cart');

  const troveOrderUuid = shopifyCart?.attributes?.troveOrderUuid;

  const inventoryItemFields = `
    color {
      code
      display
    }
    size {
      code
      display
    }
    condition {
      code
      display
    }
    images {
      tag
      url
    }
    itemStatus
    notes
    price
    sku
    uuid
  `;

  const query = `
    query inventoryItems(
      $partnerUuid: String!
      $parentSku: String!
      $sizeCodes: [String]
      $colorCodes: [String]
      $conditionCodes: [String]
      $page: Int
      $pageSize: Int
      $sortBy: InventoryItemSortCommerce
      $troveOrderUuid: String
      $includeOtherInventoryItems: Boolean!
    ) {
      mainInventoryItems: inventoryItems(
        partnerUuid: $partnerUuid
        parentSku: $parentSku
        sizeCodes: $sizeCodes
        colorCodes: $colorCodes
        conditionCodes: $conditionCodes
        page: $page
        pageSize: $pageSize
        sortBy: $sortBy
        troveOrderUuid: $troveOrderUuid
      ) {
        count
        page
        pageSize
        rows {
          ${inventoryItemFields}
        }
      }
      otherInventoryItems: inventoryItems(
        partnerUuid: $partnerUuid
        parentSku: $parentSku
        sizeCodes: $sizeCodes
        excludeWhere: {
          colorCodes: $colorCodes
          conditionCodes: $conditionCodes
        }
        page: 1
        pageSize: $pageSize
        sortBy: $sortBy
        troveOrderUuid: $troveOrderUuid
      ) @include(if: $includeOtherInventoryItems) {
        rows {
          ${inventoryItemFields}
        }
      }
    }
  `;
  const variables = {
    partnerUuid,
    parentSku,
    sizeCodes,
    colorCodes,
    conditionCodes,
    page,
    pageSize,
    sortBy,
    troveOrderUuid,
    includeOtherInventoryItems: page === 1,
  };

  const response = await fetchWithAppName(`${global.url}${param}`, {
    body: JSON.stringify({ query, variables }),
  });

  const {
    data: {
      mainInventoryItems: {
        rows: mainItems,
        count: totalMainItemsCount,
      },
      otherInventoryItems: {
        rows: otherItems,
      } = {},
    },
  } = await response.json();

  return {
    mainItems,
    totalMainItemsCount,
    otherItems,
  };
}

function renderSingleMixedStylesGrid(inventoryItems, grid) {
  inventoryItems.forEach((item) => {
    const wrapper = document.createElement('li');
    wrapper.classList.add('grid__item', 'grid__item--product');

    // Create instance of custom element, render item data.
    const card = document.createElement('card-product-mixed-styles');
    wrapper.append(card);
    card.render(item);

    grid.append(wrapper);
  });
}

let otherOptionsMessage;

function appendOtherOptionsMessage() {
  if (!otherOptionsMessage) {
    otherOptionsMessage = document.createElement('li');
    otherOptionsMessage.classList.add('grid__item', 'grid__item--other-options-below');
    otherOptionsMessage.appendChild(
      document.getElementById('card-other-options-below').content.cloneNode(true),
    );
  }
  mainItemsGrid.appendChild(otherOptionsMessage);
}

function setOtherOptionsMessageSize() {
  if (!otherOptionsMessage) return;

  let numGridColumns;
  if (window.innerWidth >= 990) {
    numGridColumns = productGridColumnCounts.desktop;
  } else if (window.innerWidth >= 750) {
    numGridColumns = productGridColumnCounts.tablet;
  } else {
    numGridColumns = productGridColumnCounts.mobile;
  }

  // Subtract 1 b/c the "more options below..." message is NOT one of the items we need to count.
  const numItems = mainItemsGrid.childNodes.length - 1;
  // Number of UUIDs remaining after the last full row.
  const numRemainingItems = numItems % numGridColumns;

  // CSS to fill up the remainder of the last grid row or else wrap to a new row if the last grid
  // row is full. The number before the forward slash is the 1-based index of the grid line to start
  // at. The number after the slash is the 1-based index of the grid line to end at. Negative
  // numbers count backwards from the end of the grid. See
  // https://developer.mozilla.org/en-US/docs/Web/CSS/grid-column for more details.
  otherOptionsMessage.style.gridColumn = `${numRemainingItems + 1} / -1`;
}

const PRODUCT_GRID_LABEL_COUNT_TOKEN = /\{\s*count\s*\}/i;

function renderMixedStylesGrids({
  mainItems,
  mainItemsCount,
  otherItems,
}) {
  renderSingleMixedStylesGrid(mainItems, mainItemsGrid);
  mainItemsTitle.textContent = productGridLabels.mainItems.replace(
    PRODUCT_GRID_LABEL_COUNT_TOKEN,
    mainItemsCount > productGridMaxInventoryCountShown ?
      `${productGridMaxInventoryCountShown.toLocaleString()}+` :
      mainItemsCount.toLocaleString(),
  );
  mainItemsSubtitle.textContent = productGridLabels.mainItesSubtitle;

  // We show the "more options..." grid provided the main grid fits within a single row on desktop
  // (and provided we have at least one UUID to show in the "more options..." grid). We use the
  // desktop column count here even on mobile or tablet on the thinking that desktop is where the
  // "sad/empty main grid" problem is the most obvious.
  if (otherItems?.length > 0 && mainItemsCount <= productGridColumnCounts.desktop) {
    renderSingleMixedStylesGrid(otherItems, otherItemsGrid);
    otherItemsTitle.textContent = productGridLabels.otherItems;
    otherItemsWrapper.classList.remove('hidden');
  }
  if (!otherItemsWrapper.classList.contains('hidden')) {
    appendOtherOptionsMessage();
    setOtherOptionsMessageSize();
    window.addEventListener('resize', setOtherOptionsMessageSize);
  }
}

function eraseMixedStylesGrids() {
  window.removeEventListener('resize', setOtherOptionsMessageSize);
  otherOptionsMessage = undefined;
  otherItemsWrapper.classList.add('hidden');
  otherItemsGrid.replaceChildren();
  mainItemsTitle.textContent = '';
  mainItemsSubtitle.textContent = '';
  mainItemsGrid.replaceChildren();
}

function showLoadingSpinner() {
  loadMoreSpinner.style.display = 'block';
}

function hideLoadingSpinner() {
  loadMoreSpinner.style.display = 'none';
}

function showLoadMore() {
  loadMoreButton.style.display = 'block';
}

function hideLoadMore() {
  loadMoreButton.style.display = 'none';
}

function setLoadMoreHasRenderedContent() {
  const hasLoadMoreWrapperContent = loadMoreSpinner.style.display !== 'none' ||
    loadMoreButton.style.display !== 'none';
  loadMoreWrapper.classList[hasLoadMoreWrapperContent ? 'add' : 'remove'](
    'load-more--has-rendered-content',
  );
}

// NOTE: As of this writing, color isn't actually a property in each variant's variant_data object.
// Listing here for future proofing. See below for how we ACTUALLY handle color.
const FACET_TYPES = ['color', 'size', 'condition'];

const codeValueByDisplayValueByFacetType = allAvailableVariants.reduce(
  (acc, nextVariant) => {
    FACET_TYPES.forEach((facetType) => {
      if (nextVariant.variant_data?.[facetType]) {
        acc[facetType] = {
          ...acc[facetType],
          [nextVariant.variant_data[facetType].display]: nextVariant.variant_data[facetType].code,
        };
      }
    });
    return acc;
  },
  {
    // As of this writing, the trove-variant.available metafield doesn't include any info about
    // color CODEs, just color display values. So seed our display value to code lookup for color
    // with product-level info. This would need to change if we every decide NOT to split up
    // mixed-styles products by color.
    // troveProduct declared by main-product-mixed-styles.liquid.
    color: {
      [troveProduct.color_display]: troveProduct.color_code,
    },
  },
);

const buildApiFilter = (
  facetType,
  displayValue,
) => displayValue ?
  [codeValueByDisplayValueByFacetType[facetType]?.[displayValue] || displayValue] :
  undefined;

let currentPage = 1;
let totalNumMainItemsRendered = 0;
let inFlightFetchMixedStylesItemsParams = null;
let renderedFetchMixedStylesItemsParams = null;

const isDuplicateFetchMixedStylesItemsRequest = (
  requestParams,
) => (
  !!inFlightFetchMixedStylesItemsParams &&
  JSON.stringify(inFlightFetchMixedStylesItemsParams) === JSON.stringify(requestParams)
) || (
  !inFlightFetchMixedStylesItemsParams &&
  JSON.stringify(renderedFetchMixedStylesItemsParams) === JSON.stringify(requestParams)
);

const shouldReplaceRenderedItems = (
  requestParams,
) => JSON.stringify(
  { ...requestParams, page: undefined },
) !== JSON.stringify(
  { ...renderedFetchMixedStylesItemsParams, page: undefined },
);

async function fetchAndRenderMixedStylesItems() {
  // The function getCurrentSelection is declared by product-variants-trove-mixed-styles.liquid,
  // which is technically only rendered if the variant_picker block type has been added. Omitting
  // that block type isn't expected in production, but we still don't want the page to fail to load
  // if that block type is forgotten. Hence supporting fallback logic to proceed without filtering
  // if that function is missing.
  const {
    size,
    condition,
    colorDisplay,
  } = typeof getCurrentSelection === 'function' ? getCurrentSelection() : {};
  const fetchMixedStylesItemsParams = {
    parentSku: troveProduct.parent_sku,
    sizeCodes: buildApiFilter('size', size),
    conditionCodes: buildApiFilter('condition', condition),
    colorCodes: buildApiFilter('color', colorDisplay),
    page: currentPage,
    pageSize: itemsToLoadMixedStyles,
    sortBy: itemSortMixedStyles,
  };

  if (isDuplicateFetchMixedStylesItemsRequest(fetchMixedStylesItemsParams)) {
    // Nothing to do.
    return;
  }

  inFlightFetchMixedStylesItemsParams = fetchMixedStylesItemsParams;

  if (shouldReplaceRenderedItems(fetchMixedStylesItemsParams)) {
    currentPage = 1;
    totalNumMainItemsRendered = 0;
    eraseMixedStylesGrids();
  }

  hideLoadMore();
  showLoadingSpinner();
  setLoadMoreHasRenderedContent();

  try {
    const {
      mainItems,
      totalMainItemsCount,
      otherItems,
    } = await fetchMixedStylesItems(fetchMixedStylesItemsParams);

    if (fetchMixedStylesItemsParams === inFlightFetchMixedStylesItemsParams) {
      totalNumMainItemsRendered += mainItems.length;

      renderMixedStylesGrids({
        mainItems,
        // Should the count reported by the API decrease for some reason as the customer is paging
        // through items, make sure to never let the displayed count dip below the number of items
        // we've already rendered (b/c that could look wonky).
        mainItemsCount: Math.max(totalMainItemsCount, totalNumMainItemsRendered),
        otherItems,
      });

      hideLoadingSpinner();

      if (currentPage * itemsToLoadMixedStyles < totalMainItemsCount) {
        showLoadMore();
      }
      setLoadMoreHasRenderedContent();

      renderedFetchMixedStylesItemsParams = fetchMixedStylesItemsParams;
    }
  } catch (e) {
    console.error(e);
  } finally {
    if (fetchMixedStylesItemsParams === inFlightFetchMixedStylesItemsParams) {
      inFlightFetchMixedStylesItemsParams = null;
    }
  }
};

async function loadMoreMixedStyles() {
  currentPage++;
  await fetchAndRenderMixedStylesItems();
}

const setProductMediaTitlePosition = () => {
  const stickyHeaderHeight = document.querySelector('sticky-header').clientHeight;
  const productMediaWrapperTitles = document.querySelectorAll('.product__media-wrapper-title');
  productMediaWrapperTitles.forEach((productMediaWrapperTitle) => {
    productMediaWrapperTitle.style.top = `${stickyHeaderHeight}px`;
  })
};

const setFiltersPosition = () => {
  const stickyHeaderHeight = document.querySelector('sticky-header').clientHeight;
  const filters = document.querySelector('.product__info-wrapper');

  if (window.innerWidth < 990) { 
    filters.style.height = 'auto';
    return;
  }
  let topPosition = stickyHeaderHeight + 5; // the 5 is used as an offset from the bottom of the stickyHeader
  filters.style.top = `${topPosition}px`;
  // We want to the filters to use up the full height of the screen,
  // minus the header and possibly the inline search bar, and to overflow scroll if necessary
  filters.style.height = `calc(100vh - ${topPosition}px)`;
}

setProductMediaTitlePosition();
setFiltersPosition();
window.addEventListener('resize', function() {
  setProductMediaTitlePosition();
  setFiltersPosition();
}, true);    

fetchAndRenderMixedStylesItems();
